import contactReducer from './contact.reducer';

export { default as contactActions } from './contact.actions';
export { types as contactTypes } from './contact.actions';
export { default as contactSelectors } from './contact.selectors';


export default contactReducer;
